var map = {
	"./Ambre-logo.avif": 911,
	"./Eventos-Hecho.avif": 186,
	"./Logo.png": 153,
	"./Oliver.jpg": 961,
	"./iconKore.avif": 82,
	"./iconVitaria.avif": 321,
	"./img2.avif": 415,
	"./img3.avif": 216,
	"./img4.avif": 457,
	"./img5.avif": 666,
	"./inicio.avif": 519,
	"./menu.avif": 667,
	"./proximos-eventos.avif": 574,
	"./reserva-hecha.avif": 394,
	"./reserva.avif": 844,
	"./servicios.avif": 342,
	"./ubicanos.avif": 302,
	"./vDe1.png": 72,
	"./vDe2.png": 51,
	"./vDe3.jpg": 502,
	"./vDe4.png": 85,
	"./vDe5.png": 188,
	"./vDm1.png": 792,
	"./vDm10.png": 202,
	"./vDm11.png": 963,
	"./vDm2.png": 403,
	"./vDm3.png": 490,
	"./vDm4.png": 917,
	"./vDm5.png": 623,
	"./vDm6.png": 935,
	"./vDm7.png": 438,
	"./vDm8.png": 473,
	"./vDm9.png": 576
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 206;